module.exports = __webpack_public_path__ + "static/media/arcdev4-estimate.5fc61929.PNG";